module.exports = __webpack_public_path__ + "img/icon-rotate-loading.790f1b28.png";